import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llegué sin saber qué esperar y salí siendo otra persona. Cuando rompí esa tabla sentí que por fin le demostré a mi mente que sí puedo con todo lo que me proponga.',
    author: '[Nombre], [Ciudad]'
  }, {
    quote: 'Llevaba años con ese miedo encima. En una noche entendí de dónde venía y lo rompí literalmente. No hay forma de explicarlo — hay que vivirlo.',
    author: '[Nombre], [Ciudad]'
  }, {
    quote: 'Pensé que era un evento motivacional más. No tiene nada que ver. Es una experiencia que se queda grabada en ti para siempre.',
    author: '[Nombre], [Ciudad]'
  }];
  return <section className="py-24 px-4 bg-white text-[#1a1a2e]" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#5B2D8E]" data-id="element-199">
          Lo que dicen quienes ya lo vivieron
        </h2>

        <div className="mb-12 rounded-2xl overflow-hidden shadow-lg" data-id="element-200">
          <img src="https://cdn.magicpatterns.com/uploads/8S76xaKSfdexpqx8EdzkkP/Testimoios.jpg" alt="Participantes celebrando después de romper sus tablas en la Noche de Impacto" className="w-full h-auto object-cover" data-id="element-201" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-202">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-8 rounded-3xl border border-gray-100 shadow-lg flex flex-col" data-id="element-203">
              <div className="text-[#F5A623] text-2xl mb-6 tracking-widest" data-id="element-204">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-lg text-gray-700 italic flex-grow mb-8 leading-relaxed" data-id="element-205">
                "{testimonial.quote}"
              </p>
              <p className="font-bold text-[#1a1a2e]" data-id="element-206">— {testimonial.author}</p>
            </div>)}
        </div>
      </div>
    </section>;
}